export default "__VITE_ASSET__DQcCnOq3__"